<app-standard-page-content-actions>
  <nav>
    <div class="input-group mb-2">
      <div class="input-group-text">
        <i-lucide name="search"></i-lucide>
      </div>
      <input
        type="search"
        class="form-control"
        autocomplete="off"
        [(ngModel)]="search"
      />
    </div>
  </nav>
  <div actions>
    @if (canFilter()) {
      <button
        type="button"
        class="btn btn-outline me-2 mb-1"
        (click)="onFilter()"
      >
        Filter
      </button>
    }
    @if (isFiltered()) {
      <button
        type="button"
        class="btn btn-outline me-2 mb-1"
        (click)="onClearFilter()"
      >
        Clear Filter
      </button>
    }

    @if (isAllRegistersPage) {
      <button
        type="button"
        authorizeEnable
        [authorizeFeature]="PackageFeature.ConsolidatedReports"
        class="btn btn-outline me-2 mb-1"
        routerLink="../reports"
      >
        Report
      </button>
    }

    @if (demoRegister && organisation) {
      <button
        type="button"
        class="btn btn-outline me-2 mb-1"
        routerLink="/organisations/{{
          organisation.organisationId
        }}/registers/{{ demoRegister.id }}"
      >
        Demo Register
      </button>
    }

    <ng-template
      authorizeShow
      [authorizeOrganisation]="OrganisationPermissionType.CreateRegister"
    >
      @if (isAllRegistersPage) {
        <button
          type="button"
          class="btn btn-outline me-2 mb-1"
          (click)="openCreateRegisterModal()"
        >
          <i-lucide name="plus"></i-lucide>
          Create Register
        </button>
      }
    </ng-template>

    <ng-template
      [authorizeShowElse]="NotOwner"
      [authorizeOrganisation]="OrganisationPermissionType.TransferOwnership"
    >
    </ng-template>
    <ng-template #NotOwner>
      <div ngbDropdown class="d-inline-block" placement="bottom-end">
        <button
          type="button"
          class="btn btn-outline mb-1"
          id="dropdownBasic1"
          ngbDropdownToggle
        >
          <i-lucide name="ellipsis-vertical"></i-lucide>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button
            type="button"
            ngbDropdownItem
            class="text-danger"
            (click)="onLeaveOrganisation()"
          >
            <i-lucide name="ban"></i-lucide>
            Leave {{ 'Organisation' | ize }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</app-standard-page-content-actions>
<app-standard-page-content-grid>
  @if (isFiltered()) {
    <h4>Filtered By - {{ filterDescription() }}</h4>
  }
  @if (filteredRegisters && filteredRegisters.length) {
    <table class="table">
      <thead>
        <tr>
          @if (!isAllRegistersPage) {
            <th class="multi-select">
              <input
                type="checkbox"
                [checked]="allRegistersSelected"
                [disabled]="reportInProgress"
                (change)="onRegistersToggled()"
              />
            </th>
          }
          <th scope="col">Name</th>
          <th scope="col">Entity</th>
          @if (displayPrimaryIntegratedCompanyName) {
            <th scope="col">Integrated Company</th>
          }
          <th scope="col">Tags</th>
          @if (isAllRegistersPage) {
            <th class="text-end" scope="col"></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (register of filteredRegisters; track $index; let i = $index) {
          <tr [class.selected]="register._selected">
            <!-- [class.sectionDisabled]= -->
            @if (!isAllRegistersPage) {
              <td class="multi-select">
                <input
                  type="checkbox"
                  [checked]="register._selected"
                  [disabled]="register._disabled || reportInProgress"
                  (change)="onRegisterToggled(register)"
                />
              </td>
            }
            <td scope="row">
              @if (isAllRegistersPage) {
                <a routerLink="../registers/{{ register.id }}">{{
                  register.name
                }}</a>
              }
              @if (!isAllRegistersPage) {
                <span>{{ register.name }}</span>
              }
            </td>
            <td scope="row">
              {{ register.entityName }}
            </td>
            @if (displayPrimaryIntegratedCompanyName) {
              <td scope="row">
                <ng-container>
                  {{ getPrimaryIntegratedCompanyName(register) }}
                </ng-container>
              </td>
            }
            <td>
              {{ getTagsDescription(register) }}
            </td>
            @if (isAllRegistersPage) {
              <td class="text-end">
                <div ngbDropdown class="d-inline-block" placement="bottom-end">
                  <button
                    type="button"
                    class="btn btn-outline"
                    id="dropdownBasic-{{ i }}"
                    ngbDropdownToggle
                  >
                    <i-lucide name="ellipsis-vertical"></i-lucide>
                  </button>
                  <div
                    ngbDropdownMenu
                    [attr.aria-labelledby]="'dropdownBasic-' + i"
                  >
                    @if (!isProduction) {
                      <button
                        type="button"
                        ngbDropdownItem
                        (click)="onExportJson(register)"
                      >
                        <i-lucide name="download"></i-lucide>
                        Export
                      </button>
                    }
                    <ng-template
                      authorizeShow
                      [authorizeOrganisation]="
                        OrganisationPermissionType.UpdateUser
                      "
                    >
                      <button
                        type="button"
                        ngbDropdownItem
                        routerLink="../settings/registers/{{ register.id }}"
                      >
                        <i-lucide name="key"></i-lucide>
                        Manage Access
                      </button>
                    </ng-template>
                    <ng-template
                      authorizeShow
                      [authorizeOrganisation]="
                        OrganisationPermissionType.DeleteRegister
                      "
                    >
                      <button
                        type="button"
                        ngbDropdownItem
                        (click)="onArchiveRegisterClick(register)"
                        class="text-danger"
                      >
                        <i-lucide name="folder"></i-lucide>
                        Archive
                      </button>
                    </ng-template>
                  </div>
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div>
      @if (!registers.length) {
        <p>There are currently no registers to display.</p>
      }

      @if (registers.length) {
        <p>All registers are filtered out.</p>
      }
    </div>
  }
</app-standard-page-content-grid>

<app-side-panel #sidePanel></app-side-panel>
